<template>
  <li>
    <!-- self -->
    <div
      class="label_area"
      @mouseover="setFocusedSpace(space.id)"
      @mouseleave="setFocusedSpace(null)"
      @contextmenu.prevent
    >
      <span class="toggle_btn" v-if="hasChild" @click="toggleOpen">
        <i :class="open ? 'bx bxs-down-arrow' : 'bx bxs-right-arrow'"></i>
      </span>
      <span v-bind:style="{color: focusedSpaceColor}" class="space_name" @click="toggleDetail">
        {{ objectType }}[{{getUmCode()}},{{ (objectData && objectData.objName) ? objectData.objName : 'なし' }},
       金額:{{getObjPrice(objectData)}}, W:{{round(spaceData.w)}}, H:{{round(spaceData.h)}}, D:{{round(spaceData.d)}}]
      </span>
      <span class="close_button" @click="toggleDetail" v-if="detail">
        <i class="bx bx-x-circle"></i>
      </span>
      <span class="full_open_button" @click="toggleFullClose" v-if="isPlan">
        <i>
          <img :src="getImage('pages/planning/ic_compress.svg')" alt="compress" width="16px" height="auto" title="すべて折りたたむ">
        </i>
      </span>
      <span class="full_open_button" @click="toggleFullOpen" v-if="isPlan">
        <i>
          <img :src="getImage('pages/planning/ic_expand.svg')" alt="expand" width="16px" height="auto" title="すべて展開">
        </i>
      </span>
    </div>
    <div class="detail_area" v-if="detail && debug">
      <div>
        <h4>空間データ</h4>
        <ul>
          <li>{{ spaceData }}</li>
        </ul>
      </div>
      <div>
        <h4>面関連</h4>
        <ul>
          <li>(表示対象外)</li>
          <!--
          <li v-for="fr in faceRelationList" :key="fr.frId">{{ fr }}</li>
          <li v-if="!faceRelationList.length">なし</li>
          -->
        </ul>
      </div>
      <div>
        <h4>オブジェクトデータ</h4>
        <ul>
          <li>{{ objectData }}</li>
          <li v-if="!objectData">なし</li>
        </ul>
      </div>
      <div>
        <h4>アトリビュート</h4>
        <ul>
          <li v-for="(att, idx) in attributeList" :key="'att-' + idx">{{ att }}</li>
          <li v-if="!attributeList.length">なし</li>
        </ul>
      </div>
      <div>
        <h4>加工データ</h4>
        <ul>
          <li v-for="(pd, idx) in processList" :key="'pd-' + idx">{{ pd }}</li>
          <li v-if="!processList.length">なし</li>
        </ul>
      </div>
    </div>
    <!-- children -->
    <ul v-if="hasChild && open">
      <dd-space-tree-item
        v-for="child in space.childrenSpaceModel"
        v-if="isActive(child)"
        :ref="'spaceTreeItemRef' + child.id"
        :key="'space-tree-' + child.id"
        :fileData="fileData"
        :space="child"
        :treeStatusMap="treeStatusMap"
        :color="focusedSpaceColor"
        :focusedMenuSpace="focusedMenuSpace"
        :editSpaceIds="editSpaceIds"
        :isFocusedParts="isFocusedParts"
        :isFocusedPartsParent="isFocusedPartsParent"
        :isFocusedOneRelatedToShelf="isFocusedOneRelatedToShelf"
        :isFocusedColor="focusedMenuSpace && child.id === focusedMenuSpace.id && (isFocusedParts || isFocusedPartsParent || isFocusedOneRelatedToShelf)"
        :isEditSpace="editSpaceIds.includes(child.id)"
        @setFocusedSpace="setFocusedSpace"
        @setSelectedSpace="setSelectedSpace"
      />
    </ul>
  </li>
</template>

<script>
import {LICENSE_TYPE, OBJECT_TYPE} from '../../../constants/Type'
import {STORAGE_KEY} from '../../../constants/App'
import * as AppUtil from '../../../utils/App'
import * as CalcUtil from '../../../utils/Calc'

export default {
  name: 'dd-space-tree-item',
  components: {
  },
  props: {
    fileData: Object,
    space: Object,
    treeStatusMap: Object,
    focusedMenuSpace: Object,
    editSpaceIds: Array,
    isFocusedParts: Boolean,
    isFocusedPartsParent: Boolean,
    isFocusedOneRelatedToShelf: Boolean,
    isFocusedColor: Boolean,
    isEditSpace: Boolean
  },
  data: function () {
    return {
      open: false,
      detail: false,
      debug: false
    }
  },
  computed: {
    hasChild: function () {
      return this.space.childrenSpaceModel && this.space.childrenSpaceModel.length
    },
    isPlan: function () {
      return this.space.parentSpaceId === 0
    },
    spaceData: function () {
      // 元データを変更しないようクローンして、子空間リストを消込み
      let copy = Object.assign({}, this.space)
      delete copy.childrenSpaceModel
      return copy
    },
    objectType: function () {
      return Object.keys(OBJECT_TYPE)
        .map(e => OBJECT_TYPE[e])
        .find(e => e.code === this.space.spaceObjectType)
        .label
    },
    // faceRelationList: function () {
    //   return this.fileData.faceRelationModelList.filter(e => e.frFace1SpaceId === this.space.id)
    // },
    objectData: function () {
      return this.fileData.objectDataModelList.find(e => e.spaceId === this.space.id)
    },
    attributeList: function () {
      return this.fileData.attributeModelList.filter(e => e.spaceId === this.space.id)
    },
    processList: function () {
      return this.fileData.processFixList.filter(e => e.pdOwnSpId === this.space.id)
    },
    materialUmCode: function () {
      return this.objectData.objElMaterialUmCode
    },
    focusedSpaceColor: function () {
      if (this.isFocusedColor) return 'blue'
      if (this.isEditSpace) return 'mediumaquamarine'
    }
  },
  methods: {
    /** 開閉切替え */
    toggleOpen: function () {
      if (this.hasChild) {
        this.open = !this.open
        this.treeStatusMap[this.space.id].open = this.open
        AppUtil.addLocalStorage(STORAGE_KEY.SPACE_TREE, this.treeStatusMap)
      }
    },
    /** 構成の初期表示 */
    toggleOpenDefault: function () {
      if (this.space.spaceObjectType === OBJECT_TYPE.UNIT.code) return
      if (this.hasChild) {
        this.open = true
        this.treeStatusMap[this.space.id].open = this.open
        AppUtil.addLocalStorage(STORAGE_KEY.SPACE_TREE, this.treeStatusMap)
        this.$nextTick(() => {
          this.space.childrenSpaceModel.forEach(child => {
            let ref = 'spaceTreeItemRef' + child.id
            this.$refs[ref][0].toggleOpenDefault()
          })
        })
      }
    },
    /** すべて展開 */
    toggleFullOpen: function () {
      if (this.hasChild) {
        this.open = true
        this.treeStatusMap[this.space.id].open = true
        AppUtil.addLocalStorage(STORAGE_KEY.SPACE_TREE, this.treeStatusMap)
        this.$nextTick(() => {
          this.space.childrenSpaceModel.forEach(child => {
            let ref = 'spaceTreeItemRef' + child.id
            this.$refs[ref][0].toggleFullOpen(true)
          })
        })
      }
    },
    /** すべて折りたたむ */
    toggleFullClose: function () {
      if (this.hasChild) {
        this.open = false
        Object.keys(this.treeStatusMap).forEach((id) => {
          this.treeStatusMap[id].open = false
        })
        AppUtil.addLocalStorage(STORAGE_KEY.SPACE_TREE, this.treeStatusMap)
      }
    },
    /** 編集空間による開閉切替え */
    toggleOpenByEdit: function (spaceIds) {
      if (this.hasChild) {
        this.open = true
        this.treeStatusMap[this.space.id].open = this.open
        AppUtil.addLocalStorage(STORAGE_KEY.SPACE_TREE, this.treeStatusMap)
        this.$nextTick(() => {
          this.space.childrenSpaceModel.forEach(child => {
            if (spaceIds.includes(child.id)) {
              let ref = 'spaceTreeItemRef' + child.id
              this.$refs[ref][0].toggleOpenByEdit(spaceIds)
            }
          })
        })
      }
    },
    /** 詳細表示切替え */
    toggleDetail: function () {
      if (this.dispTrialUserTools()) return
      this.detail = !this.detail
      this.treeStatusMap[this.space.id].detail = this.detail
      AppUtil.addLocalStorage(STORAGE_KEY.SPACE_TREE, this.treeStatusMap)
      this.setSelectedSpace(this.space.id)
    },
    /** 表示対象として有効な空間か */
    isActive: function (space) {
      // オブジェクトデータによるフィルタリング
      if (this.fileData.objectDataModelList && this.fileData.objectDataModelList.length) {
        let objectData = this.fileData.objectDataModelList.find(obj => obj.spaceId === space.id)
        if (objectData && (objectData.objEnableFlag === 0 || objectData.objDrawFlag === 0)) return false
      }
      return true
    },
    /** フォーカス空間emit */
    setFocusedSpace: function (spaceId) {
      this.$emit('setFocusedSpace', spaceId)
    },
    /** 選択空間emit */
    setSelectedSpace: function (spaceId) {
      this.$emit('setSelectedSpace', spaceId)
    },
    getObjPrice: function (obj) {
      let total = 0
      total += isNaN(obj.objCostMaterial) ? 0 : obj.objCostMaterial
      total += isNaN(obj.objCostProcess) ? 0 : obj.objCostProcess
      total += isNaN(obj.objCostConstruction) ? 0 : obj.objCostConstruction
      total += isNaN(obj.objCostOther) ? 0 : obj.objCostOther
      total += isNaN(obj.objCostFix) ? 0 : obj.objCostFix
      total += isNaN(obj.objCostEtcItem) ? 0 : obj.objCostEtcItem
      total += isNaN(obj.objCostExecution) ? 0 : obj.objCostExecution
      total += isNaN(obj.objCostMobilization) ? 0 : obj.objCostMobilization
      total += isNaN(obj.objCostMeasurement) ? 0 : obj.objCostMeasurement
      total += isNaN(obj.objCostDelivery) ? 0 : obj.objCostDelivery
      total += isNaN(obj.objCostTransport) ? 0 : obj.objCostTransport
      return total
    },
    getUmCode: function () {
      let retUmCode
      switch (this.space.spaceObjectType) {
        case OBJECT_TYPE.PARTS.code:
        case OBJECT_TYPE.UNIT.code:
        case OBJECT_TYPE.COMBINE.code:
        case OBJECT_TYPE.SETPLAN.code:
        case OBJECT_TYPE.SETPLAN_FIX.code:
        case OBJECT_TYPE.ROOM.code:
        case OBJECT_TYPE.PLAN.code:
        case OBJECT_TYPE.CELL.code:
        case OBJECT_TYPE.UNITCOMPONENT.code:
        case OBJECT_TYPE.FITTING.code:
        case OBJECT_TYPE.FITTINGSET.code:
          retUmCode = (this.objectData && this.objectData.umCode) ? this.objectData.umCode : 'なし'
          break
        case OBJECT_TYPE.ELEMENT.code:
          retUmCode = this.materialUmCode ? this.materialUmCode : 'なし'
          break
        default:
          retUmCode = 'なし'
          break
      }
      return retUmCode
    },
    /** 寸法のフォーマット */
    round: function (num) {
      let formatNum = CalcUtil.round(num)
      if (Number.isFinite(formatNum)) {
        return formatNum
      }
      return String(num)
    },
    /** お試しユーザー用ツール表示 */
    dispTrialUserTools: function () {
      let user = AppUtil.getUserInfo()
      return user && LICENSE_TYPE.TRIAL === user.licenseType
    },
    getImage: function (image) {
      return AppUtil.getDarosResource(image)
    }

  },
  mounted: function () {
    if (this.treeStatusMap && this.treeStatusMap[this.space.id]) {
      this.open = this.treeStatusMap[this.space.id].open
      this.detail = this.treeStatusMap[this.space.id].detail
      let user = AppUtil.getUserInfo()
      this.debug = user && user.menuServiceCode.tabMenuDebug
    }
  }
}
</script>
<style lang="scss" scoped>
.toggle_btn:hover, .space_name:hover, .close_button:hover {
  color: #ff4500;
  cursor: pointer;
}
.close_button i {
  vertical-align: middle;
}
.full_open_button {
  float: right;
  padding: 0px 1px;
}
.label_area {
  white-space: nowrap;
  padding: 0px;
}
.detail_area {
  padding: 5px;
  margin: 7px 2px;
  box-shadow: 0 0 1.5px rgba(102, 102, 102, 0.7);
  display: inline-block;
  ul {
    margin: 0 5px;
  }
}
ul {
  margin-left: 15px;
}
h4 {
  margin: 5px 0;
  padding: 3px;
  border-bottom: 1px solid #ff4500;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/tab/SpaceTreeItem.vue